var ButtonMessagePopup = require("app/AppLayout/ButtonMessagePopup"),
    frameThrottle      = require("enyo-perf/utils").frameThrottle,
    kind               = require("enyo/kind"),
    quickMacroize      = require("enyo/macroize").quickMacroize;

require("app/theme/IconButton--negative.less");

module.exports = kind(/** @lends  app.ProfilePage.UnsubscribeLoginRequiredMessage.prototype */ {

    /**
     * @private
     */
    name: "app.ProfilePage.UnsubscribeLoginRequiredMessage",

    /**
     * @private
     */
    kind: ButtonMessagePopup,

    /**
     * @private
     */
    classes: "app-profile-page-unsubscribe-login-required-message",

    /**
     * @private
     */
    handlers: {
        onMessageButtonTap: "onMessageButtonTap"
    },

    /**
     * @method
     * @private
     */
    initComponents: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.$.message.$.button.set("theme", "negative");
        };
    }),

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            $message    = this.$.message;

        $message.$.title.set("content", i18nService.getString("app.ProfilePage.Unsubscribe.LoginRequiredMessage.title"));
        $message.$.body.set("content", i18nService.getString("app.ProfilePage.Unsubscribe.LoginRequiredMessage.body"));
        $message.$.button.set("caption", i18nService.getString("app.ProfilePage.Unsubscribe.LoginRequiredMessage.Button.caption"));
        $message.$.button.set("tooltip", i18nService.getString("app.ProfilePage.Unsubscribe.LoginRequiredMessage.Button.tooltip"));
    },

    /**
     * Close the popup
     *
     * @private
     */
    onMessageButtonTap: function() {
        this.close();
    },

    /**
     * Closes the popup. By default this simply hides the popup. Override if the
     * popup also needs to be destroyed.
     *
     * @public
     */
    close: kind.inherit(function(sup) {
        return function() {
            var $i18nService = this.app.$.i18nService,
                $router      = this.app.$.router,
                redirectPath;

            sup.apply(this, arguments);

            redirectPath = $router.getCurrentPath() || "";
            redirectPath = "/" + redirectPath.replace(/^\/+/, "");
            redirectPath = encodeURIComponent(redirectPath);

            $router.navigate(quickMacroize("/{$language}/login/{$redirectPath}", {
                language:     $i18nService.get("language"),
                redirectPath: redirectPath
            }));
        };
    })

});
